export default (entityName, initialState={}) => (state = initialState, action) => {
  const {payload = {}} = action;
  const {entities = {}} = payload;

  if (entities[entityName]) {
    return Object.assign({}, state, entities[entityName]);
  }

  // TODO : handle delete actions?
  
  return state;
}
